export default __webpack_public_path__ + "static/media/proofs-icon-purple.f885fb5d.svg";